export const SET_ASSETS = 'SET_ASSETS'
export const ADD_ASSETS = 'ADD_ASSETS'
export const REMOVE_ASSET = 'REMOVE_ASSET'
export const REMOVE_PHOTO = 'REMOVE_PHOTO'
export const UPDATE_ASSETS = 'UPDATE_ASSETS';
export const ADD_PHOTOS = 'ADD_PHOTOS'

